<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img
          src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
          class="my-3"
          contain
          height="300"
        >
          <v-layout
            column
            fill-height
          >
            <v-card-title>
              <!-- <v-btn dark icon>
                <v-icon>chevron_left</v-icon>
              </v-btn>
              
              <v-spacer></v-spacer>

              <v-btn dark icon class="mr-3">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn> -->
            </v-card-title>

            <v-spacer></v-spacer>

            <v-card-title class="gray--text pl-5 pt-5">
              <div class="display-1 pl-5 pt-5"><span class="white--text">Ziaur Rahman</span></div>
            </v-card-title>
          </v-layout>
        </v-img>

        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">phone</v-icon>
              <!-- <v-icon color="indigo">mail</v-icon> -->
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>01738799349</v-list-tile-title>
              <!-- <v-list-tile-title>zrshishir@gmail.com</v-list-tile-title> -->
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon color="indigo">radio_button_checked</v-icon>
              <!-- <v-icon color="indigo">radio_button_unchecked</v-icon> -->
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Active</v-list-tile-title>
              <!-- <v-list-tile-title>Inactive</v-list-tile-title> -->
            </v-list-tile-content>
          </v-list-tile>
          
           <v-divider inset></v-divider>
            <v-list-tile>
                <v-list-tile-action>
                <v-icon color="indigo">location_on</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>1400 Main Street</v-list-tile-title>
                <v-list-tile-sub-title>Orlando, FL 79938</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
            </v-list>
      </v-card>
      <v-divider inset></v-divider>
      <v-list-tile-title class="font-weight-bold text-sm-center">Basic Information</v-list-tile-title>
          <v-container fluid>
                <v-layout >
                    <v-flex>
                         <v-table >
                        <v-tbody>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Present Address</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <span>Janata road, middle pirerbagh, mirpur.</span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Division</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">Dhaka</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">District</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">Dhaka</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Gender</v-card-text>
                                    </v-card>
                                </th>
                               
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">Male</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Date of Birth</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">24-08-1992</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Marital Status</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">Unmarried</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                             <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">National ID Card No</v-card-text>
                                    </v-card>
                                </th>
                                
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">19923485787847387388</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                             <tr>
                                <th>
                                    <v-card >
                                        <v-card-text class="px-0">Gini Score</v-card-text>
                                    </v-card>
                                </th>
                               
                                <td>
                                    <v-card >
                                        <v-card-text class="px-0">670</v-card-text>
                                    </v-card>
                                </td>
                            </tr>
                        </v-tbody>
                    </v-table>
                 </v-flex>   
              </v-layout>
            </v-container>
        <!-- <v-divider inset></v-divider> -->
        <v-list-tile-title class="font-weight-bold text-sm-center">Professional Information</v-list-tile-title>
          <v-container fluid>
                <v-layout justify-space-around>
                    <v-flex xs6>
                        <!-- <div class="title mb-1">Default (cover)</div> -->
                        <v-layout column>
                            <v-card >
                                <v-card-text class="px-0">Employment Type</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Monthly Income</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Educaitonal Qualification</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Institute Name</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Out Loan Availability</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Out Loan No</v-card-text>
                            </v-card>
                        </v-layout>
                    </v-flex>

                    <v-flex xs6>
                        <!-- <div class="title mb-1">Contain</div> -->
                        <v-layout column>
                           <v-card >
                                <v-card-text class="px-0">Salaried</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">55000</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Graduate</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Pabna University of Science and Technology</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">Yes</v-card-text>
                            </v-card>
                            <v-card >
                                <v-card-text class="px-0">3</v-card-text>
                            </v-card>
                        </v-layout>
                    </v-flex>
              </v-layout>
            </v-container>
        <!-- <v-divider inset></v-divider> -->
          <v-list-tile-title class="font-weight-bold text-sm-center">Upload Docs</v-list-tile-title>
            <v-container fluid>
                <v-layout justify-space-around>
                    <v-flex xs5>
                        <!-- <div class="title mb-1">Default (cover)</div> -->
                        <v-layout column>
                            <div class="subheading">National ID Card Front Page</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                            <div class="subheading pt-3">Birth Certificate</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                            <div class="subheading pt-3">Salary Certificate</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                            <div class="subheading pt-3">Bank Statement First Page</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                            <div class="subheading">Additional Document 1</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img> 
                            <div class="subheading">Additional Document 3</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img> 
                        </v-layout>
                    </v-flex>

                    <v-flex xs5>
                        <!-- <div class="title mb-1">Contain</div> -->
                        <v-layout column>
                            <div class="subheading">National ID Card Back Page</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4" ></v-img>
                            <div class="subheading pt-3">Other Govt. Issued Certificate</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4" ></v-img>
                            <div class="subheading pt-3">Utility Bill</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4" ></v-img>
                            <div class="subheading pt-3">Bank Statement Last Page</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                            <div class="subheading">Additional Document 2</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img> 
                            <div class="subheading">Additional Document 4</div>
                            <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.4"></v-img>
                        </v-layout>
                    </v-flex>
              </v-layout>
            </v-container>
      <!-- <v-divider inset></v-divider> -->
      <v-list-tile-title class="font-weight-bold text-sm-center">Funding Information</v-list-tile-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.calories }}</td>
          <td class="text-xs-center">{{ props.item.fat }}</td>
          <td class="text-xs-center">{{ props.item.carbs }}</td>
          <td class="text-xs-center">{{ props.item.protein }}</td>
          <td class="text-xs-center">{{ props.item.iron }}</td>
        </template>
      </v-data-table>
      <!-- <v-divider inset></v-divider> -->
      <v-list-tile-title class="font-weight-bold text-sm-center">Installment Information</v-list-tile-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.calories }}</td>
          <td class="text-xs-center">{{ props.item.fat }}</td>
          <td class="text-xs-center">{{ props.item.carbs }}</td>
          <td class="text-xs-center">{{ props.item.protein }}</td>
          <td class="text-xs-center">{{ props.item.iron }}</td>
        </template>
      </v-data-table>
       <div>
          <v-btn color="success">Approve</v-btn>
           <v-btn color="indigo">Disbursed</v-btn>
          <v-btn color="error">Cancel</v-btn>
          <!-- <v-btn color="warning">Reject</v-btn> -->
        </div>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data: () => ({
      desserts: [
          {
            name: 'Borrow1',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%'
          },
          {
            name: 'Borrow2',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%'
          },
          {
            name: 'Borrow3',
            calories: 262,
            fat: 16.0,
            carbs: 23,
            protein: 6.0,
            iron: '7%'
          },
         
        ],
         headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title'
        },
        { text: 'Amount', value: 'amount' },
        { text: 'Interest Amount', value: 'interest_amount' },
        { text: 'Rate', value: 'rate' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
       Profheaders: [
        {
          text: 'Employment Type',
          align: 'left',
          sortable: false,
          value: 'employment_type_id'
        },
        { text: 'Monthly Income', value: 'monthly_income' },
        { text: 'Educational Qualification', value: 'educational_qualification' },
        { text: 'Institute Name', value: 'institute_name' },
        { text: 'OutLoan Availability', value: 'out_loan_availability' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
    })
  }
</script>
